import { render } from "./BusInesstime.vue?vue&type=template&id=5ffc26a4"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BusInesstime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ffc26a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ffc26a4', __exports__)) {
    api.reload('5ffc26a4', __exports__)
  }
  
  module.hot.accept("./BusInesstime.vue?vue&type=template&id=5ffc26a4", () => {
    api.rerender('5ffc26a4', render)
  })

}


export default __exports__